// extracted by mini-css-extract-plugin
export default {"title":"g0sit6G5oK","list":"_1ShkBHCmS","imageWrapper":"_fDIiyeHDV","image":"G4q_ovHr0O"};